import React, {useMemo} from 'react';
import {Infobox} from '@flixbus/honeycomb-react';
import {useAppSelector} from '@/Pages/Common/hooks/useAppSelector';
import ContentLoader from '@/Pages/Common/ContentLoader';
import {useBusPartnerCostsQueryParams} from '@/Pages/PartnerCosts/hooks/useBusPartnerCostsQueryParams';
import {useBusPartners} from '@/Pages/Partners/hooks/useBusPartners';
import {useCountries} from '@/Pages/Countries/hooks/useCountries';
import PartnerCostsDriverCostContent from './PartnerCostsDriverCostContent/PartnerCostsDriverCostContent';

const PartnerCostsDriverCostTab: React.FC = () => {
  const {countries} = useCountries();
  const {busPartners} = useBusPartners();

  const {busPartnerId, year} = useBusPartnerCostsQueryParams();
  const busPartner = useMemo(
    () => busPartners?.find(busPartner => busPartner.id === busPartnerId),
    [busPartnerId, busPartners]
  );
  const partnerCountry = useMemo(
    () => countries?.find(country => country.id === busPartner?.countryId),
    [busPartner?.countryId, countries]
  );

  const partnerDriverCost = useAppSelector(
    ({partnerCosts}) => partnerCosts.driverCost
  );
  const regionalDriverCost = useAppSelector(
    ({partnerCosts}) => partnerCosts.countryCost?.driverCost
  );

  if (busPartnerId === null || year === null) {
    return (
      <Infobox appearance="warning">
        <p>
          Select a <strong>partner</strong> and a <strong>calendar year</strong>
        </p>
      </Infobox>
    );
  }

  if (!busPartner || !partnerCountry || !partnerDriverCost) {
    return <ContentLoader />;
  }

  return (
    <PartnerCostsDriverCostContent
      busPartner={busPartner}
      partnerCountry={partnerCountry}
      year={year}
      partnerDriverCost={partnerDriverCost}
      regionalDriverCost={regionalDriverCost}
    />
  );
};

export default React.memo(PartnerCostsDriverCostTab);
